import 'assets/css/footer.scss';
import { goToLocation } from 'assets/js/commonUtil';

import { pageMenuTabList01, pageMenuTabList02, pageMenuTabList03, pageMenuTabList04, pageMenuTabList05, pageMenuTabList06 } from 'types/common';

interface ParentProps  {
  id: string;
  url: string; 
  text: string;
  on: boolean;
}

export default function Footer() {
  const site = [{url:`https://www.chunhomall.com`, text:"쇼핑몰" }];

  const handleOpenNewTab = (url: string | URL | undefined) => {
    window.open(url, "_blank", "noopener, noreferrer");
  };


  return (
    <div className="footer">
      <div className='ft-con'>
        <div className='ft-top-section'>
          <div className='ft-nav'>
            <div className='ft-nav-col'>
              <div className='nav-col-title'>회사소개</div>
              <div className='nav-col-list'>
                {
                  pageMenuTabList01.map((item:ParentProps, index: number) => (
                  <div className='nav-col-list-text' key={index} onClick={() => goToLocation(item.url)}>{item.text}</div>
                  ))
                }
              </div>
            </div>
            <div className='ft-nav-col'>
              <div className='nav-col-title'>OEM·ODM</div>
              <div className='nav-col-list'>
                {
                  pageMenuTabList02.map((item:ParentProps, index: number) => (
                  <div className='nav-col-list-text' key={index} onClick={() => goToLocation(item.url)}>{item.text}</div>  
                  ))
                }
              </div>
            </div>
            <div className='ft-nav-col'>
              <div className='nav-col-title'>BUSINESS</div>
              <div className='nav-col-list'>
                {
                  pageMenuTabList03.map((item:ParentProps, index: number) => (
                  <div className='nav-col-list-text' key={index} onClick={() => goToLocation(item.url)}>{item.text}</div>  
                  ))
                }
              </div>
            </div>
            <div className='ft-nav-col'>
              <div className='nav-col-title'>연구개발·품질관리</div>
              <div className='nav-col-list'>
                {
                  pageMenuTabList04.map((item:ParentProps, index: number) => (
                  <div className='nav-col-list-text' key={index} onClick={() => goToLocation(item.url)}>{item.text}</div>  
                  ))
                }
              </div>
            </div>
            <div className='ft-nav-col'>
              <div className='nav-col-title'>브랜드소개</div>
              <div className='nav-col-list'>
                {
                  pageMenuTabList05.map((item:ParentProps, index: number) => (
                  <div className='nav-col-list-text' key={index} onClick={() => goToLocation(item.url)}>{item.text}</div>  
                  ))
                }
              </div>
            </div>
            <div className='ft-nav-col'>
              <div className='nav-col-title'>천호소식</div>
              <div className='nav-col-list'>
                {
                  pageMenuTabList06.map((item:ParentProps, index: number) => (
                  <div className='nav-col-list-text' key={index} onClick={() => goToLocation(item.url)}>{item.text}</div>  
                  ))
                }
              </div>
            </div>
          </div>
          <div className='ft-family'>
            <div>
              <img className='ft-family-icon' src="https://img.chunhomall.com/images/brand_site/footer-icon-YouTube_30x30.png.png" alt="" onClick={() => handleOpenNewTab('https://www.youtube.com/user/chunhofood')} />
              {/* <img className='ft-family-icon' src="https://img.chunhomall.com/images/brand_site/footer-icon-Facebook_30x30.png.png" alt="" onClick={() => handleOpenNewTab('https://www.facebook.com/chunhoNcare')}/> */}
              <img className='ft-family-icon' src="https://img.chunhomall.com/images/brand_site/footer-icon-Instagram_30x30.png.png" alt="" onClick={() => handleOpenNewTab('https://www.instagram.com/chunhoncare/')}/>
              <img className='ft-family-icon' src="https://img.chunhomall.com/images/brand_site/footer-icon-Blog_30x30.png.png" alt="" onClick={() => handleOpenNewTab('https://pf.kakao.com/_ZmrYM')}/>
            </div>
          </div>
        </div>
        <div className='ft-bottom-section'>
          <div className='ft-bottom-row sec'>
            <div>천호엔케어</div>
            <div>서울특별시 종로구 새문안로 5길 19 13층(당주동 5, 로얄빌딩)</div>
            <div>대표이사 : 황연하</div>
            <div>사업자등록번호: 220-85-40258</div>
          </div>
          <div className='ft-bottom-row first'>
            {/*<div>개인정보 처리방침</div>
            <div>법적고시</div>
            <div>이메일 무단 수집 금지</div>*/}
            <div>COPYRIGHT @chunhoNcare All Rights Reserved</div>
          </div>
          
        </div>
      </div>
    </div>
  );
}